import { Box, Button, Grid, Typography } from '@mui/material'
import React from 'react'
import UserStyles from './EditUser.module.css'

function AddUser() {
  return (
    <div className={UserStyles.UserMainPage} >
      <Box className={UserStyles.UserPage} sx={{ width: '85%' }}>

        <Typography variant='h2'>Edit user</Typography>
        
            <form>
              <label className={UserStyles.UserLabel}>First Name</label>
              <input
                className={UserStyles.UserAdmin}

                id="outlined-basic" variant="outlined" />
              <label className={UserStyles.UserLabel}> Last Name</label>
              <input
                className={UserStyles.UserAdmin}
                id="outlined-basic" variant="outlined" />
              <label className={UserStyles.UserLabel}>Email </label>
              <input
                className={UserStyles.UserAdmin}

                id="outlined-basic" variant="outlined" />
              <label className={UserStyles.UserLabel}>Phone no</label>
              <input type='number'
                className={UserStyles.UserAdmin}

                id="outlined-basic" variant="outlined" />

              <label className={UserStyles.UserLabel} >Gender</label>
              <select className={UserStyles.UserAdmin} >
                <option>Male</option>
                <option >Female</option>
              </select>


              <label className={UserStyles.UserLabel} >Select roles</label>
              <select className={UserStyles.UserAdmin} >
                <option >Admin</option>
              </select>

              <label className={UserStyles.UserLabel}>Create password</label>
              <input
                className={UserStyles.UserAdmin}

                id="outlined-basic" variant="outlined" />

              <label className={UserStyles.UserLabel}>Confirm password</label>
              <input
                className={UserStyles.UserAdmin}

                id="outlined-basic" variant="outlined" />

              <Box className={UserStyles.btnBox} >
                <Button variant="outlined" sx={{ mr: '5%', textTransform: 'lowercase' }}>Discard</Button>
                <Button variant="contained">Save changes</Button>
              </Box>
            </form>
        
      </Box>
    </div>
  )
}

export default AddUser